export default __webpack_public_path__ + "static/media/logo mappitall.79273950.svg";